/**
 * Tracking events are documented in docs/tracking/meta.md (see docs/tracking/README.md).
 * If you add, remove or change when an event is sent, update that doc in the same PR
 * and let the Acquisition and Data teams know.
 */
export enum CapiInternalEventName {
  SUBSCRIBE = "Subscribe",
}
